import { Fonts } from "Themes/Fonts";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
  },
  formInput: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "10px",
  },
  label: {
    flex: 1,
    fontWeight: 2,
    fontFamily: Fonts.primaryFontFamily,
  },
  field: {
    flex: 3,
  },
  imageContainer: {
    flex: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  image: {
    position: "relative",
    border: "solid 2px lightgray",
    cursor: "pointer",
    borderRadius: "5px",
    "& img": {
      height: "150px",
      width: "150px",
      "&:hover": {
        opacity: 0.3,
      },
    },
  },
  buttons: {
    width: "50%",
    display: "flex",
    justifyContent: "space-between",
    paddingTop: 20,
  },
  settings: {
    border: "solid 2px lightgrey",
    borderRadius: "5px",
    padding: "20px",
    marginLeft: "20px",
    backgroundColor: "white",
  },
  settingsError: {
    border: "solid 2px red",
  },
  settingsSuccess: {
    border: "solid 2px green",
  },
  passwordField: {
    width: "50%",
  },
  errorText: {
    ...Fonts.errorFont,
  },
  successText: {
    ...Fonts.errorFont,
    color: "green",
  },
  formResultsContainer: {},
};

export default styles;
